export const VIEWPORT_HEIGHT = 300;
export const BOX_SIZE = 100;
export const TRAVEL_DISTANCE = VIEWPORT_HEIGHT + BOX_SIZE;
export const CONTENT_HEIGHT = VIEWPORT_HEIGHT + TRAVEL_DISTANCE;
export const BOX_START_OFFSET = VIEWPORT_HEIGHT;
